import React, { useEffect } from 'react'
import { COPY_STRINGS } from '../../../../constants/translatedCopy'
import { getCopyByGradeband } from '../../../../services/ThemingService'
import { getStoryText, isSpanishUser } from '../utils/ASRUtils'

export default function ASRIntroduction(props) {

    const { speechProps, goToNextState, teacherMode } = props

    useEffect(() => {
        runSpeech()
    }, [])

    const runSpeech = async () => {
        const studentChecks = getCopyByGradeband(COPY_STRINGS, 'student_checks');

        if(teacherMode){
            await speechProps.speakWithPromise({ textToSpeak: studentChecks.teacher_mode_asr_initial_prompt_one })
            await speechProps.speakWithPromise({ textToSpeak: studentChecks.teacher_mode_asr_initial_prompt_two })
        }else{
          await speechProps.speakWithPromise({ textToSpeak: studentChecks.student_asr_initial_prompt })
        }
        goToNextState()
    }

    return null
}
